module.exports = __webpack_public_path__ + "static/img/service_introduce_5119_zh_h5.39a3206.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_5119_zh_h5.png
// module id = gAxG
// module chunks = 34